// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function CaretsInHorizontalWithLine(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "CaretsInHorizontalWithLine" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 19.5V4.5L9 12L3 19.5Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 4.5V19.5L15 12L21 4.5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M10.5 4H13.5V20H10.5V4Z", fill: "currentColor" }))));
});
//# sourceMappingURL=CaretsInHorizontalWithLine.js.map